class QuantityInput extends HTMLElement {
    static ELEMENT_NAME = 'quantity-input'

    static CLASSES = {
        root: QuantityInput.ELEMENT_NAME,
        input: `${QuantityInput.ELEMENT_NAME}__input`,
        button: `${QuantityInput.ELEMENT_NAME}__button`
    }

    $elements = {
        input: null,
        buttons: null,
        increaseButton: null,
        decreaseButton: null,
    }

    quantity = 1;
    max = null;
    min = 1;

    constructor() {
        super()

        // sync initial quantity
        this.quantity = this.getAttribute('value') ? parseInt(this.getAttribute('value')) : 1;
        this.max = this.getAttribute('max') ? parseInt(this.getAttribute('max')) : null;
        this.min = this.getAttribute('min') ? parseInt(this.getAttribute('min')) : 1;

        this.render();

        this.checkButtonsAvailability(this.quantity)

        // Handle Events
        this.$elements.input.addEventListener('change', this.handleInputChange)
        this.$elements.increaseButton.addEventListener('click', this.handleIncreaseButtonClick)
        this.$elements.decreaseButton.addEventListener('click', this.handleDecreaseButtonClick)
        this.addEventListener('quantity-change', event => this.checkButtonsAvailability(event.detail.value))
    }

    /**
     * EVENTS
     */
    handleInputChange = (event) => {
        this.updateQuantity(event.target.value)

        this.dispatchEvent(new CustomEvent('quantity-changed', {
            detail: { value: event.target.value },
            bubbles: true
        }))
    }

    handleIncreaseButtonClick = (event) => {
        const newQuantity = parseInt(this.quantity) + 1;

        this.updateQuantity(newQuantity)
        this.updateInputValue(newQuantity)
    }

    handleDecreaseButtonClick = (event) => {
        const newQuantity = parseInt(this.quantity) - 1;

        this.updateQuantity(newQuantity)
        this.updateInputValue(newQuantity)
    }

    /**
     * FUNCTIONS
     */
    updateQuantity(value) {
        this.quantity = parseInt(value);

        this.dispatchEvent(new CustomEvent('quantity-change', {
            detail: { value: this.quantity },
            bubbles: true
        }))
    }

    updateInputValue(value) {
        this.$elements.input.value = value

        this.dispatchEvent(new CustomEvent('quantity-changed', {
            detail: { value: value },
            bubbles: true
        }));
    }

    disableIncrease = () => {
        this.$elements.increaseButton.setAttribute('disabled', '')
    }

    enableIncrease = () => {
        this.$elements.increaseButton.removeAttribute('disabled')
    }

    disableDecrease = () => {
        this.$elements.decreaseButton.setAttribute('disabled', '')
    }

    enableDecrease = () => {
        this.$elements.decreaseButton.removeAttribute('disabled')
    }

    checkButtonsAvailability = (quantity) => {
        // disable buttons when the quantity has reached min or max values
        if (quantity <= this.min) {
            this.disableDecrease()
        } else {
            this.enableDecrease()
        }

        if (this.max !== null && quantity >= this.max) {
            this.disableIncrease()
        } else {
            this.enableIncrease()
        }
    }

    /**
     * RENDERING
     */
    renderButton(visualText, a11ytext) {
        const button = document.createElement('button')
        button.classList.add(QuantityInput.CLASSES.button)
        button.type = 'button'

        // create the visual text
        const visualTextEl = document.createElement('span');
        visualTextEl.textContent = visualText;
        visualTextEl.setAttribute('aria-hidden', 'true');

        // create the accessible text
        const a11yTextEl = document.createElement('span');
        a11yTextEl.textContent = a11ytext;
        a11yTextEl.classList.add('sr-only');

        button.appendChild(visualTextEl)
        button.appendChild(a11yTextEl)

        return button;
    }

    renderInput() {
        const input = document.createElement('input')
        input.type = 'number'

        // read values from attributes
        input.min = this.min;
        input.max = this.max;
        input.value = this.quantity;

        // pass on id, name & disabled to the input
        input.id = this.getAttribute('input-id')
        input.name = this.getAttribute('input-name')
        input.disabled = this.hasAttribute('input-disabled')

        input.classList.add(QuantityInput.CLASSES.input)

        return input;
    }

    render() {
        const increaseAttribute = 'data-button-increase';
        const decreaseAttribute = 'data-button-decrease';
        // render all relevant elements
        const plusButton = this.renderButton('+', 'Stückzahl um 1 erhöhen');
        plusButton.setAttribute(increaseAttribute, '');
        const minusButton = this.renderButton('-', 'Stückzahl um 1 verringern');
        minusButton.setAttribute(decreaseAttribute, '');
        const input = this.renderInput();

        // bring it all together
        this.appendChild(input)
        this.appendChild(plusButton)
        this.appendChild(minusButton)

        this.classList.add(QuantityInput.CLASSES.root)

        // store selectors to these elements
        this.$elements = {
            input: this.querySelector(`.${QuantityInput.CLASSES.input}`),
            buttons: this.querySelectorAll(`.${QuantityInput.CLASSES.button}`),
            increaseButton: this.querySelector(`.${QuantityInput.CLASSES.button}[${increaseAttribute}]`),
            decreaseButton: this.querySelector(`.${QuantityInput.CLASSES.button}[${decreaseAttribute}]`)
        }
    }

    /**
     * LIFECYCLE
     */
}

customElements.define(QuantityInput.ELEMENT_NAME, QuantityInput)